import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function VisitOurDallasOffice() {
  return <section data-section-id="141162" id="our-mckinney-home" className="relative w-full min-h-[600px] bg-white overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 w-full h-full z-0">
        <iframe title="Moonrise Residential Care McKinney Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106967.14582312676!2d-96.7584126!3d33.2014849!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c116d416b231b%3A0x7707e78d2238497a!2sMcKinney%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" className="w-full h-full border-0" style={{
        filter: "grayscale(100%) brightness(0.7) sepia(0.4) hue-rotate(200deg) saturate(1.8) contrast(1.1) opacity(0.85)"
      }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pointer-events-none flex justify-center lg:justify-start">
        <Card className="w-full max-w-md pointer-events-auto shadow-xl border-slate-200/50 bg-white/95 backdrop-blur-md rounded-2xl">
          <CardHeader className="pb-4">
            <CardTitle className="text-3xl font-bold text-[#091b3a] tracking-tight">
              Moonrise Residential Care
            </CardTitle>
            <CardDescription className="text-lg text-slate-600">
              Our McKinney Residential Home
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="bg-[#ffbd00]/10 p-3 rounded-full shrink-0">
                <MapPin className="w-5 h-5 text-[#ffbd00]" />
              </div>
              <div>
                <p className="font-semibold text-[#091b3a] text-lg mb-1">Home Address</p>
                <p className="text-slate-700 leading-relaxed text-base !font-normal">
                  McKinney, Texas
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-[#ffbd00]/10 p-3 rounded-full shrink-0">
                <Clock className="w-5 h-5 text-[#ffbd00]" />
              </div>
              <div>
                <p className="font-semibold text-[#091b3a] text-lg mb-1">Care Availability</p>
                <p className="text-slate-700 leading-relaxed text-base !font-normal">
                  24-Hour Attentive Care
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-[#ffbd00]/10 p-3 rounded-full shrink-0">
                <Phone className="w-5 h-5 text-[#ffbd00]" />
              </div>
              <div>
                <p className="font-semibold text-[#091b3a] text-lg mb-1">Contact Our Team</p>
                <p className="text-slate-700 leading-relaxed text-base !font-normal">972.987.0475 / 469.922.3702</p>
              </div>
            </div>
          </CardContent>
          <CardFooter className="pt-2">
            <Button asChild size="lg" className="w-full group bg-[#ffbd00] hover:bg-[#b89542] btn-primary rounded-full transition-all shadow-md hover:shadow-lg">
              <Link to="https://maps.google.com/?q=McKinney,+TX" newTab>
                <Navigation className="w-4 h-4 mr-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}